
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.434 5.002c.066-.362.066-.738.066-1.284C14.5 1.665 12.933 0 11 0S7.5 1.665 7.5 3.718c0 .55 0 .917.067 1.269.184.962.87 1.816 3.433 6.013 2.57-4.096 3.253-4.995 3.434-5.998zM11 5.268c.806 0 1.458-.694 1.458-1.55 0-.855-.652-1.549-1.458-1.549-.805 0-1.458.694-1.458 1.55 0 .855.653 1.549 1.458 1.549z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.146 11.521a1 1 0 001.701.01l.153-.243v3.298l3 3V8.914l-.92-.92c.147-.235.277-.448.392-.64.265-.444.472-.818.628-1.169l1.607 1.608A1 1 0 0117 8.5V20a1 1 0 01-1.707.707L11 16.414l-4.293 4.293a1 1 0 01-1.414 0l-5-5A1 1 0 010 15V3.5a1 1 0 011.707-.707L6 7.086l.917-.917c.156.337.36.697.617 1.126.119.198.256.421.412.673L7 8.914v8.672l3-3V11.28l.146.24zM2 5.914l3 3v8.672l-3-3V5.914z","fill":"#fff"}})])
          )
        }
      }
    